import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { Reveal } from './motion/Motion';

const SimpleFooter = () => {
  const socialLinks = [
    { name: 'Facebook', icon: 'fa-facebook-f', url: 'https://facebook.com' },
    { name: 'Instagram', icon: 'fa-instagram', url: 'https://instagram.com' },
    { name: 'Twitter', icon: 'fa-twitter', url: 'https://twitter.com' },
    { name: 'YouTube', icon: 'fa-youtube', url: 'https://youtube.com' },
  ];

  const quickLinks = [
    { label: 'Home', to: '/' },
    { label: 'Destinations', to: '/destinations' },
    { label: 'Terms & Conditions', to: '/terms' },
  ];

  const handleWhatsApp = () => {
    const message = encodeURIComponent("Hi! I want to plan an international family holiday. Can you help me?");
    window.open(`https://wa.me/1234567890?text=${message}`, '_blank');
  };

  return (
    <footer className="ee-footer" data-testid="simple-footer">
      <Reveal className="ee-footer-inner" y={20}>
        <div className="ee-footer-brand-col">
          <span className="ee-footer-brand-text display-heading">Elite Experiences</span>
          <p className="ee-footer-tagline">
            Your journey begins with us — curated international family holidays, planned end to end.
          </p>
        </div>

        <div>
          <p className="ee-footer-heading">Quick Links</p>
          <ul className="ee-footer-links">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="ee-footer-heading">Follow Us</p>
          <div className="ee-footer-social-icons">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="ee-footer-social-link"
                aria-label={social.name}
                data-testid={`social-${social.name.toLowerCase()}`}
              >
                <i className={`fa-brands ${social.icon}`}></i>
              </a>
            ))}
          </div>
          <button onClick={handleWhatsApp} className="ee-footer-whatsapp">
            <MessageCircle size={16} />
            Chat on WhatsApp
          </button>
        </div>
      </Reveal>

      <div className="ee-footer-bottom">
        <div className="ee-footer-bottom-inner">
          <p className="ee-footer-copyright">
            © {new Date().getFullYear()} Elite Experiences. All rights reserved.
          </p>
          <p className="ee-footer-made-with">Crafted for unforgettable family journeys</p>
        </div>
      </div>
    </footer>
  );
};

export default SimpleFooter;
